<template>
  <el-dialog
    title="是否原创"
    :visible.sync="visible"
    width="342px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="56px"
      :rules="rules"
      class="name-ruleForm"
    >
      <el-form-item label="原创：" prop="creativeSource">
        <el-select v-model="ruleForm.creativeSource" placeholder="请选择">
          <el-option label="是" value="是"> </el-option>
          <el-option label="否" value="否"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { setCreativeSourceFetch } from "../../api/material";
export default {
  data() {
    return {
      visible: false,
      ruleForm: {
        creativeSource: "",
      },
      rules: {
        creativeSource: [
          { required: true, message: "请选择原创类型", trigger: "change" },
        ],
      },
      folderId: null,
      fileNames: [],
    };
  },

  methods: {
    handleClose() {
      this.visible = false;
      this.$emit("clearOptionValue");
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          setCreativeSourceFetch({
            // folderId: this.folderId,
            fileNames: this.fileNames.join(","),

            creativeSource: this.ruleForm.creativeSource,
          }).then((res) => {
            if (res.code == "0000") {
              this.$message.success("分配成功");
              this.resetForm(formName);
              this.$emit("updateTags", this.folderId);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.creativeSource = "";
      this.handleClose();
    },
    showModal(creativeSource, folderId, fileNames) {
      this.visible = true;
      if (creativeSource) {
        this.ruleForm.creativeSource = creativeSource;
      }
      this.folderId = folderId;
      this.fileNames = fileNames;
    },
  },
};
</script>
<style lang="less"  >
.name-ruleForm {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .el-form-item__label {
    padding: 0 !important;
  }
}
</style>